export default {
  ru: {
    title: 'Задайте ваш вопрос',
    question_1: 'Когда основан музей?',
    question_2: 'Экспозиции',
    question_3: 'Время работы',
    question_4: 'В какие дни музей закрыт для посещения?',
    question_5: 'Территориальные отделы музея',
    question_6: 'Стоимость билета',
    question_7: 'Обзорная экскурсия для взрослых',
    question_8: 'Сувениры',
    question_9: 'Чем могу помочь',
    question_10: 'Пушкинская карта',
    // question_11: 'Притяжение Арктики',
    // question_12: 'Звёздная планета детства',
  },
  en: {
    // en
  },
};
